"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpDownTypes = void 0;
exports.useUpDownType = useUpDownType;
const vue_demi_1 = require("vue-demi");
const bridge_1 = require("../utils/bridge");
exports.UpDownTypes = {
    /** 红涨绿跌 */
    RedUpGreenDown: 0,
    /** 绿涨红跌 */
    GreenUpRedDown: 1,
    /** 粉涨绿跌 */
    PinkUpGreenDown: 2,
    /** 绿涨粉跌 */
    GreenUpPinkDown: 3,
};
/**
 * 涨跌配色：默认取活动配置的 `upDownType`（0 红涨绿跌、1 绿涨红跌），桥成功时可覆盖为客户端 `getUpDownType` 返回值。
 */
function useUpDownType(defaultType = exports.UpDownTypes.GreenUpRedDown, followClient = true) {
    const upDownType = (0, vue_demi_1.ref)(defaultType);
    try {
        if (followClient) {
            (0, bridge_1.callJSBridgeHandler)('getUpDownType', {}, (res) => {
                let parsed = res;
                if (typeof res === 'string') {
                    parsed = JSON.parse(res);
                }
                if (!parsed || typeof parsed !== 'object') {
                    return;
                }
                const body = parsed;
                if (body.result !== 0) {
                    return;
                }
                const type = body.data;
                if (type === exports.UpDownTypes.RedUpGreenDown ||
                    type === exports.UpDownTypes.PinkUpGreenDown) {
                    upDownType.value = exports.UpDownTypes.RedUpGreenDown;
                }
                else {
                    upDownType.value = exports.UpDownTypes.GreenUpRedDown;
                }
            });
        }
    }
    catch (err) {
        console.error('useUpDownType error', { err });
    }
    return upDownType;
}
